import { css } from 'emotion'
import { MenuLink, Colors } from './..'

export const NavPageStyle = css({
  // textAlign: 'center',
  marginBottom: '4rem',
  'li': {
    margin: '0 0.5rem',
  },
  'a': {
    ...MenuLink,
    color: Colors.mediumGrey,
    padding: '1rem',
    position: 'relative',
    display: 'block',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: 6,
      background: 'black',
      transition: 'all 200ms ease',
      transform: 'scaleX(0)',
      transformOrigin: 'center left',
    },
    '&:hover': {
      color: 'black',
    },
    '&.active': {
      color: 'black',
      '&:after': {
        transform: 'scaleX(1)',
      }
    }
  },
})

export const ArticleNavStyle = (hasPdf, full) => css({
  // marginTop: '4rem',
  position: 'relative',
  width: '100%',
  height: 60,
  display: 'flex',
  zIndex: 2,
  '@media (min-width: 1024px)': {
    width: 80,
    display: 'block',
  },
  '.btn':{
    borderLeft: '1px solid white',
    '@media (min-width: 1024px)': {
      borderRight: '0px',
    }
  },
  '.btn-return': {
    width: `calc(100% - ${hasPdf ? full ? 240 : 300 : 180}px)`,
    height: 60,
    lineHeight: '60px',
    '@media (min-width: 1024px)': {
      width: 80,
      height: 80,
      lineHeight: '80px',
    } 
  },
  '.panel-pdf': {
    right: full ? -120 : -60,
    zIndex: 4,
    '@media (min-width: 1024px)': {
      right: 'auto',
      left: 0,
    }
  },
  '.pdf-annotation': {
    position: 'absolute',
    top: 160,
    left: 80,
    width: 240,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.9375rem',
    padding: '1rem',
    animation: 'fadeIn 300ms ease forwards',
    animationDelay: '3000ms',
    display: 'none',
    '@media (min-width: 1024px)': {
      display: 'flex'
    },
    'svg': {
      transform: 'rotate(90deg)',
      marginRight: '1rem',
    },
    'span': {
      textAlign: 'center',
    },
    '@keyframes fadeIn': {
      '0%': {
        opacity: 1,
        transform: 'translateX(0px)'
      },
      '100%': {
        opacity: 0,
        transform: 'translateX(-20px)'
      }
    }
  },
  '.btn__arrow': {
    width: 60,
    height: 60,
    lineHeight: '60px',
    textAlign: 'center',
    display:'block',
    background: Colors.extraLightGrey,
    '@media (min-width: 1024px)': {
      display: 'none'
    },
    '&--previous': {
      'svg': {
        transform: 'scale(-1)'
      }
    },
    'svg': {
      fill: Colors.mediumGrey,
      verticalAlign: 'middle',
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/nav.js